<template>
  <div id="inspectOrganize-edit">

    <IForm :label-width="110" ref="formInline" :model="edit" :elem="editElem" :rules="editRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
        <div slot="extend">
          <Row>
            <Col span="12"><FormItem label="名称" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入机构名称" maxlength="125"/></FormItem></Col>
            <Col span="12"><FormItem label="编码" prop="code"><Input v-model="edit.code" type="text" placeholder="请输入编码"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="子公司代码" prop="siteCode"><Input v-model.trim="edit.siteCode" type="text" placeholder="请输入子公司代码" maxlength="50"/></FormItem></Col>
            <Col span="12"><FormItem label="客户代码" prop="customerCode"><Input v-model.trim="edit.customerCode" type="text" placeholder="请输入客户代码" maxlength="50"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="收样点代码" prop="collectionLocation"><Input v-model.trim="edit.collectionLocation" type="text" placeholder="请输入收样点代码" maxlength="50"/></FormItem></Col>
            <Col span="12"><FormItem label="收样点名称" prop="collectionLocationName"><Input v-model.trim="edit.collectionLocationName" type="text" placeholder="请输入收样点名称" maxlength="125"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="合同编号" prop="contractNum"><Input v-model.trim="edit.contractNum" type="text" placeholder="请输入合同编号" maxlength="50"/></FormItem></Col>
            <Col span="12"><FormItem label="标本箱号" prop="specimenBoxCode"><Input v-model.trim="edit.specimenBoxCode" type="text" placeholder="请输入标本箱号" maxlength="50"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="外勤代表帐号" prop="legworkNo"><Input v-model.trim="edit.legworkNo" type="text" placeholder="请输入外勤代表帐号" maxlength="50"/></FormItem></Col>
            <Col span="12">
              <FormItem label="类型" prop="type">
                <Select v-model="edit.type" style="width: 100%;">
                  <Option v-for="item in enums.organizeTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="联系人" prop="contactPerson"><Input v-model="edit.contactPerson" type="text" placeholder="请输入联系人" maxlength="50"/></FormItem></Col>
            <Col span="12"><FormItem label="联系电话" prop="telphone"><Input v-model="edit.telphone" type="text" placeholder="请输入联系电话" maxlength="15"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="拉取状态" prop="pull">
                <Select v-model="edit.pull" style="width: 100%;">
                  <Option v-for="item in status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem  label="推送状态" prop="push">
                <Select v-model="edit.push" style="width: 100%;">
                  <Option v-for="item in status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status" style="width: 100%;">
                  <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" prop="remark">
                <Input v-model="edit.remark" type="textarea" :autosize="{minRows: 3,maxRows: 3}" placeholder="请输入备注"/>
              </FormItem>
            </Col>
          </Row>
        </div>

      </IForm>
  </div>
</template>
<script>
import {_get,_save} from "@/services/screeningConfig/inspectOrganize.js";
import {enums} from "@/services/enums";

export default {
  name: "InspectOrganizeEdit",
  data() {
    return {
      edit: {
        id: "",
        name: "",
        code: "",
        contactPerson: "",
        telphone: "",
        siteCode: "",
        customerCode: "",
        collectionLocation: "",
        collectionLocationName: "",
        contractNum: "",
        specimenBoxCode: "",
        legworkNo: "",
        push: 1,
        pull: 1,
        type: 1,
        status: 1,
        remark: "",
      },
      enums: enums,
      init: "",
      pushOrPull:[
        {label: '开启', value: 1},
        {label: '关闭', value: 2},
      ],
      status:[
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '机构名称不能为空', trigger: 'blur'},
          {maxlength:50,message:"机构名称长度不能超过50",trigger: 'blur'}
        ],
        siteCode: [
          {required: true, message: '子公司代码不能为空', trigger: 'blur'},
        ],
        customerCode: [
          {required: true, message: '客户代码不能为空', trigger: 'blur'},
        ],
        collectionLocation: [
          {required: true, message: '收样点代码不能为空', trigger: 'blur'},
        ],
        collectionLocationName: [
          {required: true, message: '收样点名称不能为空', trigger: 'blur'},
        ],
        contractNum: [
          {required: true, message: '合同编号不能为空', trigger: 'blur'},
        ],
        specimenBoxCode: [
          {required: true, message: '标本箱号不能为空', trigger: 'blur'},
        ],
        legworkNo: [
          {required: true, message: '外勤代表帐号不能为空', trigger: 'blur'},
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
            type:'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);

      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      const params = {id: row.id};
      _get(params).then(res =>{
        this.edit = Object.assign({}, res.data);
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
